module.exports = __webpack_public_path__ + "img/icon-15.78db8599.png";